import { NoteInputStyles } from './NoteInput.types'

const makeStyles = (): NoteInputStyles => ({
	noteInput: {
		fontFamily: 'SVFont',
		fontSize: '18px',
		height: '50px',
		marginTop: '20px',
		paddingLeft: '5px',
		width: '100%'
	}
})

export default makeStyles
